import { Pipe, PipeTransform } from '@angular/core';
import { IReviewer, IReviewerModel, IReviewersModel } from '../interfaces';
import { RoleEnum } from '../enums';

@Pipe({
    name: 'ReviewerRoleFilter'
})

export class ReviewerRolePipe implements PipeTransform {


    transform(value: IReviewersModel, args: RoleEnum[]): IReviewerModel[] {
        const name = 'ApplicationStatusFilter';
        name.logWithObject('Filtering Reviewers', { value: value, args: args });
        if (value === undefined || args === undefined) {
            return undefined;
        } else {
            try {
                const list = value.Reviewers.filter(a => args.includes(a.Reviewer.PositionId));
                return list;
            } catch (err) {
                name.logWithObject('Error in filtering Reviewers', err);
                return undefined;
            }
        }
    }
}




// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/pipes/reviewer-role.pipe.ts